import { DialogContent, DialogActions, Button } from '@mui/material';
import { DATE_FORMATS } from '@callmart/types';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { useCustomStyles, useLocationsByLoggedInUserRole } from '../../hooks';
import WorkingUnitLocationAutocomplete from '../Selects/WorkingUnitLocationAutocomplete';
import ResponsiveDialog from '../UI/Dialogs/ResponsiveDialog';

const ReleaseTotalsDialog = ({
    open,
    onClose,
    date,
    onRelease,
    selectedLocations,
    onSelectedLocationsChange,
    workingUnitOptions,
    selectedWorkingUnits,
    onSelectedWorkingUnitsChange,
    isLocationMultiSelect,
    releaseButtonText,
    children,
    isLoading,
}) => {
    const { t } = useTranslation();
    const classes = useCustomStyles();
    const dialogTitle = t('bidding.releaseTotals') + ' - ' + date.format(DATE_FORMATS.MONTH_YEAR);

    const [locationOptions] = useLocationsByLoggedInUserRole({ prependAllLocationsOption: isLocationMultiSelect });

    return (
        <ResponsiveDialog
            fullScreen={false}
            fullWidth={true}
            title={dialogTitle}
            onClose={onClose}
            open={open}
            actionButtons={
                <DialogActions sx={{ ...classes.dialogActions, ...classes.marginBottom }}>
                    <Button onClick={onClose} variant="outlined" disabled={isLoading}>
                        {t('action.cancel')}
                    </Button>
                    <LoadingButton
                        onClick={onRelease}
                        variant="contained"
                        loading={isLoading}
                        disabled={selectedWorkingUnits.length === 0}
                    >
                        <span>{releaseButtonText}</span>
                    </LoadingButton>
                </DialogActions>
            }
        >
            <DialogContent>
                <WorkingUnitLocationAutocomplete
                    locationOptions={locationOptions}
                    selectedLocations={selectedLocations}
                    onSelectedLocationsChange={onSelectedLocationsChange}
                    workingUnitOptions={workingUnitOptions}
                    selectedWorkingUnits={selectedWorkingUnits}
                    onSelectedWorkingUnitsChange={onSelectedWorkingUnitsChange}
                    isLocationMultiSelect={isLocationMultiSelect}
                    isWorkingUnitMultiSelect={true}
                ></WorkingUnitLocationAutocomplete>
                {children}
            </DialogContent>
        </ResponsiveDialog>
    );
};

export default ReleaseTotalsDialog;
